import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import BlockDialog from './BlockDialog';
import { Dialog } from 'primereact/dialog';
import DeleteDialog from './DeleteDialog';
import AddUserDialog from './AddUserDialog';
import { handleGetRequest } from '../../services/GetTemplate';
import { Tag } from 'primereact/tag';

function UsersData() {
    const [viewBlockDialog, setViewBlockDialog] = useState(false);
    const [viewDeleteDialog, setViewDeleteDialog] = useState(false);
    const [addUserDialog, setAddUserDialog] = useState(false);
    const [dialogData, setDialogData] = useState();
    const [editable, setEditable] = useState(false);
    const [usersList, setUSersList] = useState();
    const [loading, setLoading] = useState(false);

    const tableData = [
        {
            userId: 'USR-2025-0781',
            name: 'Example name',
            role: 'Admin',
            status: 'Active',
            lastLogin: 'Dec 7,2025'
        },
        {
            userId: 'USR-2025-0781',
            name: 'Example name',
            role: 'Admin',
            status: 'Active',
            lastLogin: 'Dec 7,2025'
        }
    ];

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex align-item-center justify-content-center">
                <Button
                    tooltip="Edit Record"
                    icon="pi pi-pencil"
                    iconPos="center"
                    className="mr-0 p-button-rounded block__button"
                    style={{ borderRadius: '50%', border: 'none' }}
                    onClick={() => {
                        setEditable(true);
                        setAddUserDialog(true);
                        setDialogData(rowData);
                    }}
                />
                <Button tooltip="Delete Record" icon="pi pi-trash" iconPos="center" className="mr-1 ml--4 p-button-rounded delete__button" style={{ borderRadius: '50%', border: 'none' }} onClick={() => handleDelete(rowData)} />
            </div>
        );
    };

    const handleBlock = () => {
        setViewBlockDialog(true);
    };
    const onHideBlockDialog = () => {
        setViewBlockDialog(false);
    };

    const handleDelete = (rowData) => {
        setViewDeleteDialog(true);
        setDialogData(rowData?.userId);
    };
    const onHideDeleteDialog = () => {
        setViewDeleteDialog(false);
    };
    const onHideUserDialog = () => {
        setAddUserDialog(false);
        setEditable(false);
        setDialogData();
    };
    const getUsers = async () => {
        setLoading(true);
        try {
            const response = await handleGetRequest('User/getAllUser', false);
            if (response?.success === true) {
                setUSersList(response?.data);
            } else {
                setUSersList([]);
            }
        } catch (err) {
            setUSersList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getUsers();
    }, []);
    return (
        <>
            <Dialog visible={viewBlockDialog} style={{ width: '30rem' }} onHide={onHideBlockDialog}>
                <BlockDialog onHideBlockDialog={onHideBlockDialog} />
            </Dialog>
            <Dialog visible={viewDeleteDialog} style={{ width: '30rem' }} onHide={onHideDeleteDialog}>
                <DeleteDialog onHideDeleteDialog={onHideDeleteDialog} dialogData={dialogData} getUsers={getUsers} />
            </Dialog>
            <Dialog visible={addUserDialog} style={{ width: '50rem' }} onHide={onHideUserDialog} header={<div className="w-full text-center font-semibold text-xl">{editable ? 'Update User' : 'Add New User'}</div>}>
                <AddUserDialog onHideUserDialog={onHideUserDialog} dialogData={dialogData} editable={editable} getUsers={getUsers} />
            </Dialog>
            <div className="grid">
                <div className="col-12">
                    <div className="Card__Round pt-5" style={{ border: 'none' }}>
                        <div className="flex justify-between items-center w-full">
                            <div>
                                <h3 className="mb-0">User Management</h3>
                                <p className="mt-0" style={{ fontSize: '20px' }}>
                                    Manage users, permissions, and team access across your organization
                                </p>
                            </div>

                            <div className="flex gap-2 justify-end ml-auto" style={{ width: '30%' }}>
                                <Button label="Add New" icon="pi pi-plus" className="p-button-primary ml-auto Btn__Dark" onClick={() => setAddUserDialog(true)} />
                                {/* <Button label="Export" icon="pi pi-upload" className="p-button-secondary Black__Btn" /> */}
                            </div>
                        </div>

                        <div className="Table__Section mt-6" style={{ position: 'relative' }}>
                            {loading && (
                                <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.7)', zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                                </div>
                            )}
                            <DataTable
                                paginator
                                rows={5}
                                rowsPerPageOptions={[5, 10, 25]}
                                className="datatable-responsive"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                                globalFilterFields={['accountLevelName', 'createuser', 'createdate', 'lkpStatus.statusName']}
                                emptyMessage="No List found."
                                responsiveLayout="scroll"
                                value={usersList}
                            >
                                {/* <Column field="userId" header="User Id" /> */}
                                <Column field="fullName" header="Name" />
                                <Column field="roleName" header="Role" />
                                <Column field="isActive" header="Status" body={(rowData) => <Tag value={rowData.isActive ? 'Active' : 'Inactive'} severity={rowData.isActive ? 'success' : 'danger'} rounded />} />
                                <Column field={rowData => rowData.zoneName ? rowData.zoneName : "N/A"} header="Zone" />
                                {/* <Column field="lastLoginOn" header="Last Login" /> */}
                                <Column header="Action" body={(rowData) => actionBodyTemplate(rowData)} className="Table__ActionHeading__CentredAlign" />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UsersData;
